import Joi from "joi";
import { emailField } from "../../utils/validationPatterns";

const NAME_CHARS = new RegExp("^[\\p{L}\\p{M}\\p{N}\\s'-]+$", "u");

const required = (key: string) => ({
  "any.required": `validation.${key}`,
  "string.empty": `validation.${key}`,
});

/** The owner sign-up form. Its messages are `validation.*` keys, translated where they are shown. */
export const registerSchema = Joi.object({
  entity_name: Joi.string()
    .trim()
    .min(2)
    .max(30)
    .required()
    .messages({
      ...required("companyNameRequired"),
      "string.min": "validation.companyNameLength",
      "string.max": "validation.companyNameLength",
    }),
  entity_description: Joi.string()
    .trim()
    .max(250)
    .optional()
    .allow(null, "")
    .messages({ "string.max": "validation.companyDescriptionLength" }),
  user_first_name: Joi.string()
    .trim()
    .min(2)
    .max(18)
    .pattern(NAME_CHARS)
    .required()
    .messages({
      ...required("firstNameRequired"),
      "string.min": "validation.firstNameLength",
      "string.max": "validation.firstNameLength",
      "string.pattern.base": "validation.firstNameChars",
    }),
  user_last_name: Joi.string()
    .trim()
    .min(2)
    .max(18)
    .pattern(NAME_CHARS)
    .required()
    .messages({
      ...required("lastNameRequired"),
      "string.min": "validation.lastNameLength",
      "string.max": "validation.lastNameLength",
      "string.pattern.base": "validation.lastNameChars",
    }),
  user_email: emailField("validation.emailRequired", "validation.emailInvalid"),
  user_password: Joi.string()
    .trim()
    .required()
    .messages(required("passwordRequired")),
  user_country_code: Joi.string()
    .trim()
    .required()
    .messages(required("countryRequired")),
  user_agree_terms: Joi.boolean().invalid(false).required().messages({
    "any.invalid": "validation.termsRequired",
    "any.required": "validation.termsRequired",
  }),
});
